import { Input, OnChanges } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { patient } from "../../../../icemedx-lib/src/models/domain/patient";
import { encounterindex } from "../../../../icemedx-lib/src/models/ehr/encounterindex";
import { DomainService } from "../../../../icemedx-lib/src/services/domain/domain.service";
import { Iceutility } from "../../../../icemedx-lib/src/services/iceutility";
import { AppService } from "../../../../../src/app/app.service";
import { userTypes } from "../../../../icemedx-lib/src/login/login.config";
import { IceTypes } from "../../../../icemedx-lib/src/models/icetypes";
import { Router } from "@angular/router";
import { IceNavService } from "../../../../icemedx-lib/src/components/ice-nav/ice-nav.service";

@Component({
  selector: 'app-listofencounters',
  templateUrl: './listofencounters.component.html',
  styleUrls: ['./listofencounters.component.scss']
})
export class ListOfEncountersComponent implements OnInit, OnChanges {
  @Input() encounters: encounterindex[] = [];
  currentPatient: string;
  selectedEncounter: encounterindex;
  hasAccess: boolean = true;

  constructor(private appSvc: AppService, private domainSvc: DomainService, private navSvc: IceNavService, private dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufExternalDocuments).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.hasAccess = false;

      setTimeout(_ => {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    }
  }

  ngOnChanges(changeObj) {
    if (Iceutility.isdefined(changeObj.encounters) && Iceutility.isdefined(changeObj.encounters.previousValue)) {
      if (changeObj.encounters.currentValue !== changeObj.encounters.previousValue && this.hasAccess) {
        if (this.encounters.length > 0) {
          this.encounters = changeObj.encounters.currentValue;

          if (this.encounters.length > 0) {
            for (let enc of this.encounters) {
              this.getProviderNames(enc, enc['PROVS']);
              this.setPatientName(enc, enc.patient_trans_account);
            }
          }
        }
      }
    }
  }

  public getEncounterType(encounter) {
    let statusNote = encounter.appointment_status_note;
    return encounter._appointment_status_text + (!Iceutility.isStringUndefinedNullOrEmpty(statusNote) ? (" - " + statusNote) : "");
  }

  public getEncounters() {
    /// TODO
  }

  public navigateToEncounter(encounter) {
    this.router.navigate([this.navSvc.buildRoute("PHR/Encounter?domain=" + encounter.patient_trans_account + "&akey=&key=" + encounter.encounter_key + "&status=", true)]);
  }

  public showEncounterDetails(templateRef, selectedEncounter) {
    this.selectedEncounter = selectedEncounter;

    this.dialog.open(templateRef, {
      width: '500px',
      panelClass: 'ice-dialog'
    });
  }

  private getProviderNames(encounter, providers) {
    let providerAccounts: string[] = [];

    if (Iceutility.isdefined(providers)) {
      for (let prv of providers) {
        providerAccounts.push(prv.trans_account);
      }
    }

    this.domainSvc.getProviderNames(providerAccounts)
      .subscribe(_ => {
        encounter._provider_names = providerAccounts.map(p => {
          if (!Iceutility.isStringUndefinedNullOrEmpty(p.trim())) {
            return DomainService.mappedProviders[p.trim().toLowerCase()];
          }
          return "";
        }).join(", ");
      }, error => console.log(error));
  }

  private setPatientName(enounter, ptAct) {
    this.domainSvc.getPatient(ptAct, this.appSvc.getCurrentAccount()).subscribe(
      data => {
        if (data != null && data.length > 0) enounter.patient_name = this.appSvc.getPatientName(<patient>data[0]);
      });
  }
}
